<script>
  import SettingContactListAdd from "../Components/Steps/SettingContactListAdd.svelte";
  import SettingContactListRemove from "../Components/Steps/SettingContactListRemove.svelte";
  import SettingDelay from "../Components/Steps/SettingDelay.svelte";
  import SettingIfElse from "../Components/Steps/SettingIfElse.svelte";
  import SettingSplit from "../Components/Steps/SettingSplit.svelte";
  import SettingTarget from "../Components/Steps/SettingTarget.svelte";
  import SettingSendEmail from "../Components/Steps/SettingSendEmail.svelte";
  import SettingSendEmailNotification from "../Components/Steps/SettingSendEmailNotification.svelte";
  import SettingSendSMS from "../Components/Steps/SettingSendSMS.svelte";
  import SettingSendWhatsApp from "../Components/Steps/SettingSendWhatsApp.svelte";
  import SettingSendVoice from "../Components/Steps/SettingSendVoice.svelte";
  import SettingContactTagAdd from "../Components/Steps/SettingContactTagAdd.svelte";
  import SettingContactTagRemove from "../Components/Steps/SettingContactTagRemove.svelte";
  import SettingContactPropertyChange from "../Components/Steps/SettingContactPropertyChange.svelte";
  import SettingContactNoteAdd from "../Components/Steps/SettingContactNoteAdd.svelte";
  import SettingContactDelete from "../Components/Steps/SettingContactDelete.svelte";
  import SettingContactUnsubscribe from  "../Components/Steps/SettingContactUnsubscribe.svelte";
  import SettingStartAutomation from "../Components/Steps/SettingStartAutomation.svelte";
  import SettingEndAutomation from "../Components/Steps/SettingEndAutomation.svelte";
  import SettingTriggerWebhook from "../Components/Steps/SettingTriggerWebhook.svelte";
  import { ignore } from "../../Common/tools";
  import SettingMemberGroupAdd from "../Components/TriggerActions/SettingMemberGroupAdd.svelte";
  import SettingMemberGroupRemove from "../Components/TriggerActions/SettingMemberGroupRemove.svelte";
  import SettingLmsEnroll from '../Components/Steps/SettingLmsEnroll.svelte';

  export let data;
  export let automation;
  export let stepId;
  export let automationSave;
  export let stepAdd;
  export let stepUpdate;
  export let order;
  export let onChange = ignore;

  let instance;

  let valid;
  let error;

  export function get() {
    return data;
  }

  export function isValid() {
    return valid;
  }

  export function getError() {
    return error;
  }
</script>

<div class="col20 f-left small-rules mb-25">
  {#if data.type === "DELAY"}
    <SettingDelay bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type === "IF_ELSE"}
    <SettingIfElse bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type === "SPLIT"}
    <SettingSplit bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type === "TARGET"}
    <SettingTarget bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "SEND_EMAIL"}
    <SettingSendEmail
      bind:data
      bind:this={instance}
      bind:valid
      bind:error
      automation={automation}
      stepId={stepId}
      automationSave={automationSave}
      stepAdd={stepAdd}
      stepUpdate={stepUpdate}
      order={order}
      onChange={onChange} />
  {:else if data.type == "SEND_EMAIL_NOTIFICATION"}
    <SettingSendEmailNotification
      bind:data
      bind:this={instance}
      bind:valid
      automation={automation}
      stepId={stepId}
      automationSave={automationSave}
      stepAdd={stepAdd}
      stepUpdate={stepUpdate}
      order={order}
      onChange={onChange} />
  {:else if data.type == "SEND_SMS"}
    <SettingSendSMS bind:data bind:this={instance} bind:valid bind:error automation={automation} onChange={onChange} />
  {:else if data.type == "SEND_WHATSAPP"}
    <SettingSendWhatsApp bind:data bind:this={instance} bind:valid bind:error automation={automation} onChange={onChange} />
  {:else if data.type == "SEND_VOICE"}
    <SettingSendVoice bind:data bind:this={instance} bind:valid bind:error onChange={onChange} />
  {:else if data.type == "CONTACT_TAG_ADD"}
    <SettingContactTagAdd bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "CONTACT_TAG_REMOVE"}
    <SettingContactTagRemove bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "CONTACT_PROPERTY_CHANGE"}
    <SettingContactPropertyChange bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "CONTACT_LIST_ADD"}
    <SettingContactListAdd bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "CONTACT_LIST_REMOVE"}
    <SettingContactListRemove bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "CONTACT_MEMBER_GROUP_ADD"}
    <SettingMemberGroupAdd bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "CONTACT_MEMBER_GROUP_REMOVE"}
    <SettingMemberGroupRemove bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "CONTACT_NOTE_ADD"}
    <SettingContactNoteAdd bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "CONTACT_DELETE"}
    <SettingContactDelete bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "CONTACT_UNSUBSCRIBE"}
    <SettingContactUnsubscribe bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "START_AUTOMATION"}
    <SettingStartAutomation bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "END_AUTOMATION"}
    <SettingEndAutomation bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "TRIGGER_WEBHOOK"}
    <SettingTriggerWebhook bind:data bind:this={instance} bind:valid onChange={onChange} />
  {:else if data.type == "CONTACT_LMS_ENROLL"}
    <SettingLmsEnroll bind:data bind:this={instance} bind:valid onChange={onChange} enroll={true} />
  {:else if data.type == "CONTACT_LMS_UNENROLL"}
    <SettingLmsEnroll bind:data bind:this={instance} bind:valid onChange={onChange} enroll={false} />
  {:else}{/if}
</div>
